module.exports = __webpack_public_path__ + "static/media/itIcon.805f5497.svg";